import React, { useEffect, useState } from 'react';
import Modal from '../common/Modal.js';
import Button from '../common/Button.js';
import FormInput from '../common/FormInput.js';
import SelectField from '../common/SelectField.js';

const InventoryDialog = ({
  isOpen,
  onClose,
  onSave,
  item = null,
  categoryOptions = [],
  loading = false
}) => {
  const [form, setForm] = useState({
    name: '',
    category: '',
    stock: '',
    purchasePrice: '',
    minStock: ''
  });
  const [errors, setErrors] = useState({});

  useEffect(() => {
    if (item) {
      setForm({
        name: item.name || '',
        category: item.category || '',
        stock: item.stock?.toString() || '',
        purchasePrice: item.purchasePrice?.toString() || '',
        minStock: item.minStock?.toString() || ''
      });
    } else {
      setForm({ name: '', category: '', stock: '', purchasePrice: '', minStock: '' });
    }
    setErrors({});
  }, [item, isOpen]);

  const handleChange = (field, value) => {
    setForm((prev) => ({ ...prev, [field]: value }));
    if (errors[field]) {
      setErrors((prev) => ({ ...prev, [field]: '' }));
    }
  };

  const validate = () => {
    const nextErrors = {};
    if (!form.name.trim()) nextErrors.name = 'Name is required';
    if (!form.category) nextErrors.category = 'Category is required';
    if (form.stock === '' || Number(form.stock) < 0) nextErrors.stock = 'Enter a valid quantity';
    if (form.purchasePrice === '' || Number(form.purchasePrice) < 0) nextErrors.purchasePrice = 'Enter a valid price';
    if (form.minStock === '' || Number(form.minStock) < 0) nextErrors.minStock = 'Enter a minimum stock threshold';
    setErrors(nextErrors);
    return Object.keys(nextErrors).length === 0;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!validate()) return;

    onSave({
      name: form.name.trim(),
      category: form.category,
      stock: Number(form.stock),
      purchasePrice: Number(form.purchasePrice),
      minStock: Number(form.minStock)
    });
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} title={item ? 'Edit Inventory Item' : 'Create Inventory Item'} size="medium">
      <form onSubmit={handleSubmit} className="space-y-6">
        <FormInput
          id="itemName"
          name="name"
          label="Item Name"
          placeholder="Enter inventory item name"
          value={form.name}
          onChange={(e) => handleChange('name', e.target.value)}
          error={errors.name}
          required
        />

        <div className="grid gap-4 md:grid-cols-2">
          <SelectField
            id="itemCategory"
            name="category"
            label="Category"
            options={categoryOptions}
            value={form.category}
            onChange={(e) => handleChange('category', e.target.value)}
            error={errors.category}
            required
          />
  
        </div>

        <div className="grid gap-4 md:grid-cols-3">
          <FormInput
            id="itemStock"
            name="stock"
            label="Stock"
            type="number"
            placeholder="Available stock"
            value={form.stock}
            onChange={(e) => handleChange('stock', e.target.value)}
            error={errors.stock}
            required
          />
          <FormInput
            id="itemPurchasePrice"
            name="purchasePrice"
            label="Purchase Price"
            type="number"
            placeholder="Cost"
            value={form.purchasePrice}
            onChange={(e) => handleChange('purchasePrice', e.target.value)}
            error={errors.purchasePrice}
            required
          />
          <FormInput
            id="itemMinStock"
            name="minStock"
            label="Minimum Stock"
            type="number"
            placeholder="Alert threshold"
            value={form.minStock}
            onChange={(e) => handleChange('minStock', e.target.value)}
            error={errors.minStock}
            required
          />
        </div>

        <Modal.Actions>
          <Button type="button" variant="secondary" onClick={onClose} disabled={loading}>
            Cancel
          </Button>
          <Button type="submit" variant="primary" loading={loading}>
            {item ? 'Save Item' : 'Create Item'}
          </Button>
        </Modal.Actions>
      </form>
    </Modal>
  );
};

export default InventoryDialog;
